import styled from 'styled-components';

import { bidiText } from 'components/bidi';

export const Person = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s3);
  min-width: 0;
  padding: var(--s3);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  background: var(--surface);
`;

export const Who = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  ${bidiText};
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-body);
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.div`
  ${bidiText};
  font-size: var(--fs-micro);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text-faint);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Badge = styled.div`
  flex: 0 0 auto;
`;
